import { render, staticRenderFns } from "./ModalStudyConfirm.vue?vue&type=template&id=0f53aabe&scoped=true&lang=pug"
import script from "./ModalStudyConfirm.vue?vue&type=script&lang=ts"
export * from "./ModalStudyConfirm.vue?vue&type=script&lang=ts"
import style0 from "./ModalStudyConfirm.vue?vue&type=style&index=0&id=0f53aabe&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f53aabe",
  null
  
)

export default component.exports